import { LinkedinShareButton, LinkedinIcon } from "react-share";
import React from "react";

/* eslint-disable react/prop-types */
const LinkedinShare = ({ url, title }) => {
    return (
        <LinkedinShareButton
            url={url}
            quote={title}
        >
            <LinkedinIcon
                size={40}
                round
            />
        </LinkedinShareButton>
    )
}

export default LinkedinShare;